import { context } from '@shopware-ag/meteor-admin-sdk';

import enGB from './en-GB.json';
import deDE from './de-DE.json';

// Common i18n configuration structure
const createI18nConfigObject = (locale: string, fallbackLocale: string) => ({
    legacy: false,
    globalInjection: true,
    locale,
    fallbackLocale,
    messages: {
        'en-GB': enGB,
        'de-DE': deDE,
    },
});

// Default locale constants
const DEFAULT_LOCALE = 'en-GB';
const DEFAULT_FALLBACK_LOCALE = 'en-GB';

// Create async function to get i18n config with proper locale
export async function createI18nConfig() {
    // Get locale from Shopware context
    const localeResponse = await context.getLocale();
    
    const locale = localeResponse.locale || DEFAULT_LOCALE;
    const fallbackLocale = localeResponse.fallbackLocale || DEFAULT_FALLBACK_LOCALE;
    
    const i18nConfig = createI18nConfigObject(locale, fallbackLocale);

    console.log('Locale set to:', i18nConfig.locale);
    
    return i18nConfig;
}

// For backward compatibility, export default with fallback config
const defaultConfig = createI18nConfigObject(DEFAULT_LOCALE, DEFAULT_FALLBACK_LOCALE);

export default defaultConfig;
